if (typeof $ == 'undefined') $ = jQuery;

/*
 * Turn two numbers into a percentage, rounded
 * 
 * @param   Int  amount  The number to base the percentage on
 * @param   Int  total  The total (100%)
 * @return  Int  Number, rounded to 2 decimal places
 */
function convertToPercentage(amount,total){
	var 
		percentage = (amount / total) * 100,
		rounded = ( Math.round(percentage * 10000) / 10000 );
	
	return rounded;
}

/*
 * Turn a percentage in a pixel value
 * 
 * @param   Int  percentage  The perecentage to convert
 * @param   Int  total  The total (100%)
 * @return  String  Pixel value
 */
function convertFromPercentage(percentage,total){
	var 
		amount = (total / 100) * percentage,
		pixels = Math.round(amount) + 'px';
		
	return pixels;
}

/*
 * Turn two numbers into a percentage, rounded
 * 
 * @param   string  string  string containing 'px'
 * @return  string  a string without 'px'
 */
function removePX(string){
	if ( string.indexOf('px') < 0)
		return false;
	
	var end = string.indexOf('px');
	return Number( string.substr(0, end) );
}

//Front-end (Allow access to Util functions)
if ( typeof MUR != 'undefined'){
	MUR.convertToPercentage = convertToPercentage;
	MUR.convertFromPercentage = convertFromPercentage;
	MUR.removePX = removePX;

//Back-end (Controls the functionality of custom ACF field)
} else {

	var SetLocation = {
		init:function(){
			var _ = this;
			
			var $els = {
				$container: $('.set-location--container'),
				$trigger  : $('.modal-trigger'),
				$modal    : $('.set-location--modal'),
				$close    : $('.save-location'),
				$icon     : $('.neighborhood-icon'),
				$field    : $('[data-coordinates]'),
				$checkbox : $('[name="fullscreen-mode"]')
			}
			
			$.extend(_,$els);
			
			var Pos = {
				width     : _.$modal.find('.inner').width(),
				height    : _.$modal.find('.inner').height()
			}
			
			if ( this.$field.val() != 0 ){
				var temp = this.$field.val().split(',');
				Pos['offsetX'] = convertFromPercentage( temp[0], Pos.width );
				Pos['offsetY'] = convertFromPercentage( temp[1], Pos.height );
			
			} else {
				Pos['offsetX'] = Math.round(Pos.width / 2);
				Pos['offsetY'] = Math.round(Pos.height / 2);
			}
			
			$.extend(_,Pos);
			
			_.$icon.css(
				{
					top: Pos['offsetY'],
					left: Pos['offsetX']
				}
			);
			
			_.$icon.draggable();
			
			this.isFullscreen = !! Number( Cookies.get('fullscreen') );
			
			if ( this.isFullscreen )
				this.$checkbox[0].checked = true;
			
			this.events();
		},
		events:function(){
			this.$trigger.click( this.triggerModal.bind(this) );
			this.$close.click( this.saveLocation.bind(this) );
			this.$checkbox.change( this.setCookie.bind(this) )
			
			$(document)
				.on( 
					'webkitfullscreenchange' +
					' fullscreenchange'      + 
					' mozfullscreenchange'   + 
					' msfullscreenchange'    
				, this.fullScreenChange.bind(this)	
			);
		},
		triggerModal:function(){
			if (this.isFullscreen){
				this.$modal.FullScreen();
			} else {
				$('body').addClass('overflow-hidden').prepend( this.$modal.addClass('modal-is-active') );
			}
		},
		setCookie:function(e){
			var 
				$el = $(e.currentTarget),
				val;
			
			if ( $el.is(':checked') ){
				val = 1;
			} else {
				val = 0;
			}
			
			this.isFullscreen = !!val;
			Cookies.set('fullscreen', val, { expires: 360, path: '/' });
		},
		fullScreenChange:function(e){
			if ( !$('body').hasClass('fullscreen-active') )
				return;
			
			$('body').removeClass('fullscreen-active');
			this.$modal.removeClass('modal-is-active');
		},
		saveLocation:function(){
			if ( this.isFullscreen ){
				this.$modal.FullScreen();
			} else {
				$('body').removeClass('overflow-hidden');
				this.$modal.removeClass('modal-is-active');
			}
			
			this.offsetX = removePX( this.$icon.css('left') );
			this.offsetY = removePX( this.$icon.css('top') );
			
			var concat = [
				convertToPercentage( this.offsetX, this.width ),
				convertToPercentage( this.offsetY, this.height )
			].join(',');
			
			this.$field.val(concat);
			
			this.$container.find('.status').addClass('notice').find('b').html('Location just set');
		}
	}
	
	jQuery(document).ready( function(){
		
		/*
		 * jQuery plugin API: Standardize fullscreen API method
		 * 
		 *  @return	false|void
		 */
		$.fn.FullScreen = function(){
			var 
				elem = document.createElement('test'),
				props = [
					"requestFullscreen",
					"webkitRequestFullscreen",
					"msRequestFullscreen",
					"mozRequestFullScreen"
				],
				exit = [
					"exitFullscreen",
					"webkitExitFullscreen",
					"webkitCancelFullscreen",
					"msExitFullscreen",
					"mozCancelFullscreen"
				],
				avail = false;
			
			if ( this.hasClass('modal-is-active') ){
				
				//Check if we need to close out..	
				for ( var i in exit ) {
					var prop = exit[i];
					var result = document[prop] !== undefined ? prop : false;
					if (result){
						document[prop]();
						return;
					} 
				}
			
			} else {
				
				//Check if we can activate fullscreen
				for ( var i in props ) {
					var prop = props[i];
					var result = elem[prop] !== undefined ? prop : false;
					if (result){
						avail = prop;
						break;
					} 
				}
				
			}
			
			if (!avail) return false;
			
			this.addClass('modal-is-active').each(function(){
				this[avail]();
			});
			
			setTimeout(function(){
				$('body').addClass('fullscreen-active');
			},1500);
		}
		
		SetLocation.init();
	});

}
